/* istanbul ignore file */

export enum MapState {
    hidden = 'hidden',
    inContent = 'inContent',
    sticky = 'sticky',
    uninitialized = 'uninitialized'
}
